// extracted by mini-css-extract-plugin
export var cardContainer = "_qq-0";
export var cardHeader = "_qq-2";
export var collapsedState = "_qq-3";
export var dragHandle = "_qq-5";
export var dragHandleIcon = "_qq-6";
export var dragging = "_qq-1";
export var titleArea = "_qq-4";